import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "giveaway" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "user-side"
}
const _hoisted_4 = { class: "avatar winner" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Time = _resolveComponent("Time")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.giveaway.name), 1),
      (!_ctx.giveaway.winner?.user)
        ? (_openBlock(), _createBlock(_component_Time, {
            key: 0,
            endDate: _ctx.endDate
          }, null, 8, ["endDate"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.giveaway.winner?.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _mergeProps({ class: "avatar-wrapper" }, _ctx.$attrs), [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.giveaway.winner.user.avatar,
                alt: _ctx.giveaway.winner.user.name
              }, null, 8, _hoisted_5),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "winner-badge" }, [
                _createElementVNode("span", null, "WINNER")
              ], -1))
            ])
          ], 16),
          _createElementVNode("p", null, _toDisplayString(_ctx.giveaway.winner.user.name), 1)
        ]))
      : (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          type: "primary__white",
          class: "giveaway-button",
          disabled: _ctx.giveaway.is_participant,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'giveaways' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
          ]),
          _: 1
        }, 8, ["disabled"])),
    _createElementVNode("img", {
      class: "hover-image",
      src: _ctx.giveaway.item.thumbnail,
      alt: "",
      "aria-hidden": "true"
    }, null, 8, _hoisted_6)
  ]))
}